var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuideTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_28213",
    "data-name": "Group 28213",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37922",
    "data-name": "Path 37922",
    d: "M12,0A12,12,0,1,1,0,12,12,12,0,0,1,12,0Z",
    fill: "#fffaea"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37725",
    "data-name": "Path 37725",
    d: "M-1102.455,510.1l-4.029-4.016,1.2-1.2,2.827,2.817,7.553-7.618,1.2,1.192Z",
    transform: "translate(1112.484 -492.883)",
    fill: "#fc3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideTrue);
export default __webpack_public_path__ + "static/media/guide-true.dd87f4ab039e94327264c13d4291353b.svg";
export { ForwardRef as ReactComponent };